import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryConfig } from '@/lib/react-query';

import httpService from '../../../lib/http.service';

export const getContractPdf = (contractId: number): Promise<{ data: Blob }> => {
  return httpService.get(`/contracts/${contractId}/pdf`, {
    responseType: 'blob',
  });
};

export const getContractPdfQueryOptions = (contractId: number) => {
  return queryOptions({
    queryKey: ['unsigned-contract'],
    queryFn: () => getContractPdf(contractId),
  });
};

type UseContractPdfOptions = {
  params: { contractId: number };
  queryConfig?: QueryConfig<typeof getContractPdfQueryOptions>;
};

export const useContractPdf = ({ params, queryConfig }: UseContractPdfOptions) => {
  return useQuery({
    ...getContractPdfQueryOptions(params.contractId),
    ...queryConfig,
  });
};
